import React, { useEffect, useRef, useState } from "react";
import * as func from "../../common/manipurCommon/FunctionCalls";
import * as api from "../../common/manipurCommon/API";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { usePermissions } from "../../common/PermissionContext";
import Select from "react-select";
import { Link, useLocation } from "react-router-dom";
import ImageWithBasePath from "../../../core/data/img/ImageWithBasePath";
import Swal from "sweetalert2";
import Utils from "../../common/manipurCommon/Utils";

const ExtCompAthltEntry = () => {

    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [athltEntryList, setAthltEntryList] = useState<any[]>([]);
    const [competitionList, setCompetitionList] = useState<any[]>([]);
    const [searchInput, setSearchInput] = useState("");
    const [entryId, setEntryId] = useState("");
    const [athleteId, setAthleteId] = useState("");
    const [compId, setCompId] = useState("");
    const [weighinWeight, setWeighinWeight] = useState("");
    const [weightClass, setWeightClass] = useState("");
    const [status, setStatus] = useState("");
    const [openModal, setOpenModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchExternalCompAthlt();
    }, []);

    async function fetchExternalCompAthlt() {
        setIsLoading(true);
        const externalAthltEntry = await func.externalCompAthltEntry(null);
        setAthltEntryList(Array.isArray(externalAthltEntry) ? externalAthltEntry : [])
        setIsLoading(false);
    }

    const filteredData = athltEntryList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const compRender = (rowData) => {
        return <span>{rowData.competitionName}</span>;
    };

    const athleteRender = (rowData) => {
        return <span>{rowData.athleteName}</span>;
    };

    const weighinWeightRender = (rowData) => {
        return <span>{rowData.extComWeighInWeight}</span>;
    };

    const weightRender = (rowData) => {
        return <span>{rowData.extComWeightClass}</span>;
    };

    const sinclairRender = (rowData) => {
        return <span>{rowData.extComSinclairCoefficient}</span>;
    };

    const robiWorldRecordRender = (rowData) => {
        return <span>{rowData.extComRobiWorldRecordTotal}</span>;
    };

    const statusRender = (rowData) => {
        return <span>{(rowData.status == 1) ? "Active" : "Inactive"}</span>;
    };

    async function newExtCompAthltEntry() {
        const athltResponse = await func.externalCompAthletes(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
        const eventResponse = await func.externalCompEvents(null);
        setCompetitionList(Array.isArray(eventResponse) ? eventResponse : []);
        setOpenModal(true);
    }

    const editDetails = (rowData) => {
        return (
            <Link to="#" onClick={() => editAthleteEntry(rowData)}>
                <i className="feather-edit"></i>Edit
            </Link>
        );
    };

    const deleteDetails = (rowData) => {
        const entryId = rowData.extComAthleteEntryId;
        return (
            <Link to="#" onClick={() => deleteAthleteEntry(entryId)}>
                <i className="feather-trash"></i>Delete
            </Link>
        );
    };

    async function editAthleteEntry(rowData: { extComAthleteEntryId: any; }) {
        const entryId = rowData.extComAthleteEntryId;
        setIsEdit(true);
        setOpenModal(true);
        const athltResponse = await func.externalCompAthletes(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : []);
        const eventResponse = await func.externalCompEvents(null);
        setCompetitionList(Array.isArray(eventResponse) ? eventResponse : []);
        const getDetails = await func.externalCompAthltEntry(entryId);
        setEntryId(getDetails.extComAthleteEntryId);
        setAthleteId(getDetails.extComAthleteId)
        setCompId(getDetails.extComCompetitionId)
        setWeighinWeight(getDetails.extComWeighInWeight)
        setWeightClass(getDetails.extComWeightClass)
        // setSinclairCoeffecient(getDetails.extComSinclairCoefficient)
        // setRobiWorldRecordTotal(getDetails.extComRobiWorldRecordTotal)
        setStatus(getDetails.status)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {
            if (isEdit) {
                updateAthleteEntry();
            } else {
                const formData = new FormData();
                formData.append("extComCompetitionId", compId);
                formData.append("extComAthleteId", athleteId);
                formData.append("extComWeighInWeight", weighinWeight);
                formData.append("extComWeightClass", weightClass);

                const createEntry = api.ExternalCompetitionAthleteEntry;
                fetch(createEntry, {
                    method: "POST",
                    headers: {
                        "Authorization": 'Bearer ' + Utils.getAccessToken()
                    },
                    body: formData
                })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.error == false) {
                            Swal.fire({
                                title: 'Success',
                                text: result.message,
                                icon: 'success',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            }).then((res) => {
                                if (res.isConfirmed) {
                                    // window.location.reload(); // 🔁 Reload only after OK is clicked
                                    setOpenModal(false);
                                    fetchExternalCompAthlt();
                                }
                            });
                        } else {
                            if (result.code == 401) {
                                Utils.logoutUser();
                            }
                            Swal.fire({
                                title: 'Error',
                                text: result.message,
                                icon: 'error',
                                confirmButtonText: 'OK',
                                allowOutsideClick: false,
                                allowEscapeKey: false
                            })
                        }
                    })
            }
        }
    }

    function updateAthleteEntry() {
        const formData = new FormData();
        formData.append("extComCompetitionId", compId);
        formData.append("extComAthleteId", athleteId);
        formData.append("extComWeighInWeight", weighinWeight);
        formData.append("extComWeightClass", weightClass);
        formData.append("status", status);

        const createEntry = api.ExternalCompetitionAthleteEntry + '/' + entryId;
        fetch(createEntry, {
            method: "POST",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
            body: formData
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setIsEdit(false);
                            setOpenModal(false);
                            fetchExternalCompAthlt();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })
    }

    function deleteAthleteEntry(entryId: string) {
        const deleteEntry = api.ExternalCompetitionAthleteEntry + '/' + entryId + '/0';
        fetch(deleteEntry, {
            method: "DELETE",
            headers: {
                "Authorization": 'Bearer ' + Utils.getAccessToken()
            },
        })
            .then((response) => response.json())
            .then((result) => {
                if (result.error == false) {
                    Swal.fire({
                        title: 'Success',
                        text: result.message,
                        icon: 'success',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    }).then((res) => {
                        if (res.isConfirmed) {
                            // window.location.reload(); // 🔁 Reload only after OK is clicked
                            setOpenModal(false);
                            fetchExternalCompAthlt();
                        }
                    });
                } else {
                    if (result.code == 401) {
                        Utils.logoutUser();
                    }
                    Swal.fire({
                        title: 'Error',
                        text: result.message,
                        icon: 'error',
                        confirmButtonText: 'OK',
                        allowOutsideClick: false,
                        allowEscapeKey: false
                    })
                }
            })

    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Athlete Competition Entry</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newExtCompAthltEntry() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Athlete Entry">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>

                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComCompetitionId"
                                                header="Competition"
                                                body={compRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete"
                                                body={athleteRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComWeighInWeight"
                                                header="Weighin Weight"
                                                body={weighinWeightRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComWeightClass"
                                                header="Weight"
                                                body={weightRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComSinclairCoefficient"
                                                header="Sinclair Coeffecient"
                                                body={sinclairRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="extComRobiWorldRecordTotal"
                                                header="Robi World Record Total"
                                                body={robiWorldRecordRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="status"
                                                header="Status"
                                                body={statusRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {currentPermissions.includes("edit") ?
                                                <Column
                                                    className="text-link"
                                                    body={editDetails}
                                                ></Column>
                                                : null
                                            }
                                            {currentPermissions.includes("delete") ?
                                                <Column
                                                    className="text-link"
                                                    body={deleteDetails}
                                                ></Column>
                                                : null
                                            }
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal
                size="xl"
                centered
                show={openModal}>
                <ModalHeader>
                    <ModalTitle>
                        <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Athlete Competition Entry</h4>
                    </ModalTitle>
                    <Button
                        variant=""
                        className="btn-close"
                        onClick={() => setOpenModal(false)}
                    ></Button>
                </ModalHeader>
                <ModalBody>
                    <form ref={formRef}>
                        <div className="row">
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Athlete </label>
                                    <Select
                                        value={athleteList.find(athlt => athlt.extComAthleteId === athleteId) ? {
                                            value: compId,
                                            label: athleteList.find(athlt => athlt.extComAthleteId === athleteId).extComAthleteName
                                        } : null}
                                        onChange={(e) => {
                                            setAthleteId(e.value);
                                        }}
                                        styles={customSelect}
                                        required
                                        options={athleteList.map(athlt => ({
                                            value: athlt.extComAthleteId,
                                            label: athlt.extComAthleteName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Competition </label>
                                    <Select
                                        value={competitionList.find(cmp => cmp.extComEventId === compId) ? {
                                            value: compId,
                                            label: competitionList.find(cmp => cmp.extComEventId === compId).extComEventName
                                        } : null}
                                        onChange={(e) => {
                                            setCompId(e.value);
                                        }}
                                        styles={customSelect}
                                        // required
                                        options={competitionList.map(cmp => ({
                                            value: cmp.extComEventId,
                                            label: cmp.extComEventName
                                        }))}>
                                    </Select>
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">WeighIn Weight</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="extComWeighInWeight"
                                        value={weighinWeight}
                                        onChange={(e) => { setWeighinWeight(e.target.value) }}
                                        placeholder="Enter Weighin Weight" />
                                </div>
                            </div>
                            <div className="col-lg-3">
                                <div className="input-space">
                                    <label className="form-label">Weight Class</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        required
                                        name="extComWeightClass"
                                        value={weightClass}
                                        onChange={(e) => { setWeightClass(e.target.value) }}
                                        placeholder="Enter Weight Class" />
                                </div>
                            </div>
                            {isEdit ?
                                <>
                                    <div className="row">
                                        <div className="mb-10 col-lg-6" style={{ paddingTop: "1rem" }}>
                                            <label className="form-label">Status</label>
                                        </div>
                                        <div className="mb-10 col-lg-2" style={{ paddingTop: "1rem" }}>
                                            <div className="form-check form-switch d-flex align-items-center justify-content-end">
                                                <input
                                                    className="form-check-input text-end"
                                                    type="checkbox"
                                                    checked={status === '1'}
                                                    id="performStatus"
                                                    onChange={(e) => {
                                                        setStatus(e.target.checked ? '1' : '0')
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </> : null
                            }
                        </div>
                        <ModalFooter>
                            <Button
                                className="btn-primary text-uppercase"
                                variant="success"
                                type="submit"
                                onClick={handleSubmit}
                            >
                                <b><i className="fas fa-save" />Save</b>
                            </Button>
                        </ModalFooter>
                    </form>
                </ModalBody>
            </Modal>
        </>
    );
};

export default ExtCompAthltEntry;